"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioIcon = exports.StyledRadioLabel = exports.StyledPill = exports.StyledDefaultLabel = exports.StyledRadioInput = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

var _animations = require("../animations.styled");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 1.1875rem 0 0;\n  display: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: fit-content;\n  padding: 0.2rem 1rem;\n  border: 1px solid ", ";\n  background: transparent;\n  border-radius: 20px;\n  cursor: pointer;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n  line-height: 27px;\n\n  ", ";\n\n  ", "\n\n  &:hover {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        ", " 0.35s ease 2\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  user-select: none;\n  ", ";\n  ", ";\n  ", ";\n\n  animation: ", ";\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  display: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.disabled && "opacity: 0.3;");
};

var StyledRadioInput = _styledComponents.default.input.attrs({
  type: 'radio'
})(_templateObject2()); // ************************************************
// ******** STYLE RADIO COMPONENT AS DEFAULT *********
// ************************************************


exports.StyledRadioInput = StyledRadioInput;
var StyledDefaultLabel = (0, _styledComponents.css)(_templateObject3(), function (props) {
  return "color: ".concat(props.color || 'inherit');
}, function (props) {
  return disabledStyle(props);
}, function (props) {
  return !props.disabled && "cursor: pointer";
}, function (props) {
  return !props.previouslySelected && props.isSelected && (0, _styledComponents.css)(_templateObject4(), _animations.SelectAnimation) || 'none';
}, function (props) {
  return props.isSelected && (0, _styledComponents.css)(_templateObject5(), props.backgroundColor ? props.backgroundColor : (0, _colors.getRGBOpacity)((0, _colors.normaliseColor)(props.theme.responseItem.hoverBackgroundColor, props.theme), 0.3));
}); // ************************************************
// ************************************************
// ************************************************
// ******** STYLE RADIO COMPONENT AS PILL *********
// ************************************************

exports.StyledDefaultLabel = StyledDefaultLabel;
var StyledPill = (0, _styledComponents.css)(_templateObject6(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.pillSelector.borderColor, props.theme);
}, function (props) {
  return disabledStyle(props);
}, function (props) {
  return props.isSelected && (0, _styledComponents.css)(_templateObject7(), props.theme.pillSelector.activeColor.backgroundColor, props.theme.pillSelector.hoverColor, props.theme.pillSelector.activeColor.textColor);
}, function (props) {
  return !props.disabled && props.theme.pillSelector.hoverColor;
}, function (props) {
  return !props.disabled && !props.isSelected && props.theme.pillSelector.hoverColor;
}); // ************************************************
// ************************************************

exports.StyledPill = StyledPill;

var StyledRadioLabel = _styledComponents.default.label(_templateObject8(), function (props) {
  return props.styleAs === 'pill' ? StyledPill : StyledDefaultLabel;
});

exports.StyledRadioLabel = StyledRadioLabel;

var StyledRadioIcon = _styledComponents.default.div(_templateObject9(), function (props) {
  return props.hide && 'none';
});

exports.StyledRadioIcon = StyledRadioIcon;